import { Tooltip, useTheme } from '@material-ui/core';
import { PauseIcon, PlayIcon, Typography } from '@room-match/shared-ui-components';
import { FileItem } from 'pages/PastSelfTapes/PastSelfTape/RoleDetails/RoleDetails.styles';
import React, { useEffect, useState } from 'react';
import { IMediumAttributes } from 'shared/interfaces/IMedium';

interface Props {
  aud: IMediumAttributes;
}

const AudioItem: React.FC<Props> = ({ aud }) => {
  const isDark = useTheme().palette.type === 'dark';
  const [audio] = useState(new Audio(aud.modified_attachment || aud.attachment));
  const [duration, setduration] = useState(0);
  const [playing, setplaying] = useState(false);

  useEffect(() => {
    const getAudioInfo = (e: any) => {
      setduration(e.target.duration);
    };

    const onEnded = () => {
      setplaying(false);
    };

    audio.addEventListener('loadedmetadata', getAudioInfo);
    audio.addEventListener('ended', onEnded);

    return () => {
      audio.pause();
      audio.removeEventListener('loadedmetadata', getAudioInfo);
      audio.removeEventListener('ended', onEnded);
    };
  }, [audio, aud]);

  const handleClick = (e: any) => {
    e.stopPropagation();
    // if (check) return;
    // playing ? audio.pause() : audio.play();
    console.log(aud.attachment_url, aud);

    if (playing) {
      audio.pause();
    } else {
      audio.play();
    }
    setplaying(!playing);
  };
  return (
    <Tooltip title={aud?.medium?.data?.attributes?.file_name || aud.medium.file_name}>
      <FileItem onClick={() => window.open(`${aud.modified_attachment || aud.attachment}`, '_blank')}>
        {playing ? (
          <PauseIcon onClick={handleClick} fontSize="small" style={{ marginRight: 8 }} />
        ) : (
          <PlayIcon onClick={handleClick} style={{ marginRight: 8 }} />
        )}
        <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Typography
            style={{
              // maxWidth: 140,
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              color: isDark ? '#fff' : '#000',
            }}
            fontSize={13}
          >
            {aud?.medium?.data?.attributes?.file_name || aud.medium.file_name}
          </Typography>
          <Typography fontSize={11} color="primary">
            <>
              {duration === 0
                ? '--:--'
                : duration < 3600
                  ? new Date(duration * 1000).toISOString().substring(14, 19)
                  : new Date(duration * 1000).toISOString().substr(11, 8)}
            </>
          </Typography>
        </div>

        {/* <Typography fontSize={12}>{duration}</Typography> */}
      </FileItem>
    </Tooltip>
  );
};

export default AudioItem;
